// extracted by mini-css-extract-plugin
export default {"headerBar":"NewFeedback_headerBar__4SWIe"};